import React from "react"
import styled from 'styled-components'

class FrontText extends React.Component {
    render() {
        const { html } = this.props
         

        return(
            <Container>
                <EntryContent dangerouslySetInnerHTML={{ __html: html }}/>
            </Container>
        )
    }

}

const Container = styled.div`
    margin-bottom: 4rem;
    .front_landing_highlight {
        padding-left: 1.5rem;
        border-left: 2px solid #FF0000;
        margin-left: 1.5rem;
    }
`
const EntryContent = styled.div`
    img {
        max-width: 100%;
        height: auto;
    }
`

export default FrontText


